import { Unpublished } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import { SITUACAO_PUBLICACAO_PAUTA } from '@/dominio/SituacaoPublicacaoPauta';

class CancelarDisponibilizacaoPautaLote extends ReactComponent {
    dialogListagemOpen = false;
    motivo = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogListagemOpen: observable,
            motivo: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleConfirmarCancelamento: action,
            configurarValorInicialCancelamento: action,
            processosCancelamento: computed,
            quantidadeProcessosSelecionados: computed,
            desabilitarCancelamento: computed,
            limparProcessoPesquisa: action,
            processos: computed,
            processosSelecionados: computed,
            existeProcessoParaCancelamento: computed,
            quantidadeProcessosCancelamento: computed,
            mensagemLoteSemProcessos: computed,
            handleMotivo: action,
            renderMotivo: computed,
            renderConteudo: computed
        });
    }

    handleClickIcone = async () => {
        this.dialogListagemOpen = true;
        this.configurarValorInicialCancelamento();
    };

    handleCloseDialog = () => {
        this.dialogListagemOpen = false;
    };

    handleConfirmarCancelamento = async () => {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Cancelando disponibilizações dos processos',
            indeterminate: true,
            qtdTotalProcessos: this.processosSelecionados.length,
            lotesProcessos: [this.processosSelecionados],
            funcaoOperacao: this.cancelarDisponibilizacoesProcessos
        });
        await this.sessaoStore.recarregarListaProcessos();
    };

    cancelarDisponibilizacoesProcessos = async () => {
        let resultado = await this.sessaoService.cancelarDisponibilizacoesDiario(
            this.pautaJulgamentoStore.idPautaSelecionada,
            this.processosSelecionados.map((registro) => registro.processo.numeroCompleto),
            this.motivo
        );
        this.pautaJulgamentoStore.atualizarProcessamentoLote(resultado);
        return resultado;
    };

    configurarValorInicialCancelamento() {
        this.processos.forEach((registro) => {
            this.store.uncheckOperacoesEmLote(registro);
        });
    }

    get processosCancelamento() {
        return this.processosSelecionados;
    }

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    get quantidadeProcessosSelecionados() {
        return this.processosSelecionados.length;
    }

    get desabilitarCancelamento() {
        return !this.existeProcessoParaCancelamento;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processos() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter(
            (registro) =>
                registro.confirmadaPublicacaoPauta === true &&
                registro.materiaPublicacaoPauta &&
                registro.materiaPublicacaoPauta.situacao ===
                    SITUACAO_PUBLICACAO_PAUTA.LIBERADO_PARA_DISPONIBILIZACAO.id &&
                this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get existeProcessoParaCancelamento() {
        return this.quantidadeProcessosCancelamento > 0;
    }

    get quantidadeProcessosCancelamento() {
        return this.processosCancelamento.length;
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => {
            return (
                registro.confirmadaPublicacaoPauta === true &&
                registro.materiaPublicacaoPauta &&
                registro.materiaPublicacaoPauta.situacao === SITUACAO_PUBLICACAO_PAUTA.LIBERADO_PARA_DISPONIBILIZACAO.id
            );
        });
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos para cancelar disponibilização' + this.complementoMensagemFiltrando;
    }

    handleMotivo = (event) => {
        this.motivo = event.target.value;
    };

    isStringPreenchida(string) {
        return string && (string + '').trim() !== '';
    }

    render() {
        return (
            <Fragment>
                <div
                    style={{ marginRight: '10px', paddingLeft: '5px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Cancelar disponibilização em diário de processos'}
                        placement="top-start"
                    >
                        <Unpublished
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={this.handleClickIcone}
                        />
                    </Tooltip>
                </div>
                {this.dialogListagemOpen && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        <DialogTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        flexGrow: 1
                                    }}
                                >
                                    <h4 style={{ margin: '0px' }}>Cancelar disponibilização em diário de processos</h4>
                                    <div style={{ margin: '0px 10px' }}>
                                        <NumeroProcesso
                                            dense
                                            tooltip="Número do processo a ser pesquisado na listagem"
                                            callbackOnChange={this.callbackNumeroProcesso}
                                            clickLimpar={this.limparProcessoPesquisa}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                margin: '10px',
                                                paddingTop: '5px'
                                            }}
                                        >
                                            <PainelFiltros />
                                        </div>
                                        <FiltroRapido id="filtroRapidoConfirmarPublicarProcessosLote" />
                                    </div>
                                </div>
                            </div>
                            {this.renderMotivo}
                        </DialogTitle>
                        {this.renderConteudo}
                    </Dialog>
                )}
            </Fragment>
        );
    }

    get renderMotivo() {
        return (
            <>
                <div style={{ marginBottom: '15px', marginTop: '15px' }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '3px 0px',
                            paddingLeft: '10px'
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            color="primary"
                            style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        >
                            <b>Motivo do cancelamento</b>
                        </Typography>
                        <TextField
                            id={'motivo'}
                            value={this.motivo}
                            multiline={true}
                            onChange={this.handleMotivo}
                            variant="outlined"
                            fullWidth={true}
                            size={'small'}
                            maxRows={10}
                        />
                    </div>
                </div>
            </>
        );
    }

    get renderConteudo() {
        return this.sessaoStore.carregandoProcessos ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    disableShrink
                    style={{ margin: '20px' }}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos...
                </Typography>
            </div>
        ) : (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                />
                <DialogActions>
                    <Button
                        onClick={this.handleCloseDialog}
                        color="secondary"
                        variant="outlined"
                        endIcon={<CancelIcon />}
                    >
                        Fechar
                    </Button>
                    <Tooltip
                        placement="top"
                        title={
                            'Selecione os processos e informe o motivo para cancelamento da disponibilização em diário.'
                        }
                    >
                        <span>
                            <Button
                                onClick={this.handleConfirmarCancelamento}
                                color="primary"
                                variant="outlined"
                                endIcon={<CheckIcon />}
                                disabled={
                                    !this.processosSelecionados ||
                                    this.processosSelecionados.length === 0 ||
                                    !this.isStringPreenchida(this.motivo)
                                }
                            >
                                Confirmar
                            </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Fragment>
        );
    }
}

export default inject('stores')(observer(CancelarDisponibilizacaoPautaLote));
